var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H1C0.44775 21 0 20.5527 0 20V10C0 4.95605 1.89014 1.61719 5.61768 0.0756809C6.12793 -0.134279 6.7124 0.107421 6.92432 0.617681C7.13526 1.12842 6.89258 1.71289 6.38233 1.92432C3.67383 3.04395 2.24365 5.36328 2.02881 9H9C9.55225 9 10 9.44775 10 10V20C10 20.5527 9.55225 21 9 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21H15C14.4477 21 14 20.5527 14 20V10C14 4.95605 15.8901 1.61719 19.6177 0.075681C20.1265 -0.134279 20.7124 0.107421 20.9243 0.617671C21.1353 1.12841 20.8926 1.71288 20.3823 1.92431C17.6738 3.04395 16.2437 5.36328 16.0288 9H23C23.5523 9 24 9.44775 24 10V20C24 20.5527 23.5523 21 23 21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.4bfb357c2fad51f983db6ed4121c183d.svg";
export { ForwardRef as ReactComponent };